/**
 * @Author: v_jppjpeng
 * @Date: 2024-12-02 10:12:28
 * @Explain: 自动化活动
 */
import http from '../http';

const MODEL = '/campaign_auto';

export default {
  // 列表
  getList(data: Record<any, any>) {
    return http.post(`${MODEL}/list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 校验名称
  checkName(data: Record<any, any>) {
    return http.post(`${MODEL}/check_name`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取来源列表
  getSourceList(data: Record<any, any>) {
    return http.post(`${MODEL}/sources`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取双重确认订阅 - 特定地点
  getOptInSpecificRegions(data: Record<any, any>) {
    return http.post(`${MODEL}/opt_in_regions`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 添加
  onAdd(data: Record<any, any>) {
    return http.post(`${MODEL}/add`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 编辑
  onEdit(data: Record<any, any>) {
    return http.post(`${MODEL}/edit`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 详情
  getDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/details`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取旅程偏好统计
  getPreferenceStatistics(data: Record<any, any>) {
    return http.post(`${MODEL}/statistics`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 删除
  onDel(data: Record<any, any>) {
    return http.post(`${MODEL}/delete`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 开始
  onStart(data: Record<any, any>) {
    return http.post(`${MODEL}/start`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 暂停
  onSuspend(data: Record<any, any>) {
    return http.post(`${MODEL}/suspend`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 终止
  onTermination(data: Record<any, any>) {
    return http.post(`${MODEL}/stop`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
